import AgoraRTC, { 
    IAgoraRTCClient,
    ILocalTrack, 
    IMicrophoneAudioTrack, 
    MicrophoneAudioTrackInitConfig 
} from "agora-rtc-sdk-ng"
import AgoraManager from "./AgoraManager"

/**
 * Agora manager that handles Audio (only) tracks
 */
class AgoraAudioManager extends AgoraManager 
{
    /**
     * Audio track
     */
    tracks: IMicrophoneAudioTrack | undefined
    onError: (error: unknown, deviceId?: string) => void

    constructor(client: IAgoraRTCClient, onError: (error: unknown, deviceId?: string) => void)
    {
        super({})
        this.client = client
        this.onError = onError
    }
    
    /**
     * Creates microphone audio track and saves it into the `tracks` property
     * @param config 
     * @returns 
     */
    async initialize(config: MicrophoneAudioTrackInitConfig)
    {
        this.tracks = await AgoraRTC.createMicrophoneAudioTrack(config)
        return this.tracks
    }

    /**
     * Publish or unpublish the `track` for this object
     * 
     * @param publish 
     * @param deviceId 
     * @returns 
     */
    async publish(publish: boolean, deviceId?: string)
    {
        if(!this.tracks)
            throw new Error("Track is not initialized")
        if(!this.client)
            throw new Error("Client is not initialized")

        if(publish)
        {
            if(deviceId)
                this.tracks.setDevice(deviceId)

            this.tracks.on("track-ended", () => {
                console.log("Audio track ended >>", this.tracks)
                this.publish(false, deviceId)
                this.onError("TRACK_ENDED", deviceId)
            })

            await this.client.publish(this.tracks)
            return true
        }
        else
        {
            await this.client.unpublish(this.tracks)
            this.tracks.removeAllListeners()
            this.tracks.close()
            this.tracks = undefined
            return false
        }
    }

    /**
     * Unpublish the track and disables the localTrack
     */
    async destroy()
    {
        if(this.tracks)
        {
            try
            {
                await this.client?.unpublish(this.tracks)
            }
            catch(error)
            {
                console.warn("Destroy agora audio manager", error)
            }

            try
            {
                AgoraManager.destroyTrack((this.tracks as ILocalTrack))
                console.debug("Track destroyed", this.tracks)
            }
            catch(error)
            {
                console.warn("Destroy audio tracks", error)
            }
            finally
            {
                this.tracks = undefined
            }
        }
    }
}

export default AgoraAudioManager
